import { c as _c } from "react/compiler-runtime";
import { useForm, zodResolver } from '@repo/sdk/form';
import { useMutation } from '@repo/sdk/tanstack';
import { z } from '@repo/sdk/zod';
import { Button, Form, FormControl, FormField, FormItem, FormMessage, Input, Separator, Spinner } from '@repo/ui/components';
import { checkEmailAction } from '@/app/_components/welcome-modal/action.ts';
import { useWelcomeModalContext } from '@/app/_components/welcome-modal/context.tsx';
import SocialButton from '../_components/social-button.tsx';
const CheckEmailForm = () => {
  const $ = _c(34);
  const {
    email,
    setEmail,
    setStep
  } = useWelcomeModalContext();
  let t0;
  let t1;
  let t2;
  if ($[0] !== email) {
    const schema = z.object({
      email: z.string().email()
    });
    t2 = useForm;
    t0 = {
      email
    };
    t1 = zodResolver(schema);
    $[0] = email;
    $[1] = t0;
    $[2] = t1;
    $[3] = t2;
  } else {
    t0 = $[1];
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t0 || $[5] !== t1) {
    t3 = {
      defaultValues: t0,
      resolver: t1
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const form = t2(t3);
  let t4;
  if ($[7] !== setEmail || $[8] !== setStep) {
    t4 = {
      mutationFn: async data => {
        setEmail(data.email);
        const {
          exist
        } = await checkEmailAction(data);
        exist ? setStep("login") : setStep("new-user");
      }
    };
    $[7] = setEmail;
    $[8] = setStep;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const {
    isPending,
    mutate: register
  } = useMutation(t4);
  let t5;
  if ($[10] !== form || $[11] !== register) {
    let t6;
    if ($[13] !== register) {
      t6 = data_0 => register(data_0);
      $[13] = register;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    t5 = form.handleSubmit(t6);
    $[10] = form;
    $[11] = register;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[15] !== form.control) {
    t6 = <FormField control={form.control} name="email" render={_temp} />;
    $[15] = form.control;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== isPending) {
    t7 = isPending && <Spinner />;
    $[17] = isPending;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== isPending || $[20] !== t7) {
    t8 = <Button className="font-semibold" disabled={isPending} type="submit">NEXT {t7}</Button>;
    $[19] = isPending;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Separator className="shrink" />;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="flex items-center gap-4">{t9}or<Separator className="shrink" /></div>;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t5 || $[25] !== t6 || $[26] !== t8) {
    t11 = <form className="flex flex-col gap-4" onSubmit={t5}>{t6}{t8}{t10}</form>;
    $[24] = t5;
    $[25] = t6;
    $[26] = t8;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  let t13;
  let t14;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <SocialButton source="google" />;
    t13 = <SocialButton source="microsoft" />;
    t14 = <SocialButton source="apple" />;
    $[28] = t12;
    $[29] = t13;
    $[30] = t14;
  } else {
    t12 = $[28];
    t13 = $[29];
    t14 = $[30];
  }
  let t15;
  if ($[31] !== form || $[32] !== t11) {
    t15 = <><Form {...form}>{t11}{t12}{t13}{t14}</Form></>;
    $[31] = form;
    $[32] = t11;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  return t15;
};
export default CheckEmailForm;
function _temp(t0) {
  const {
    field
  } = t0;
  return <FormItem><FormControl><Input {...field} placeholder="E-mail" /></FormControl><FormMessage /></FormItem>;
}